export { default } from './NewPinResetForm';
